import commonMessage from "../../constant/commonMessage";
import {
  validateEmail,
  validateMobileNumber,
  validateName,
  validatePassword,
} from "../../utils/regexValidatorHelper";

const {
  EMAIL_REQUIRED,
  INVALID_EMAIL,
  PASSWORD_REQUIRED,
  CONFIRM_PASSWORD_REQUIRED,
  NEW_PASSWORD_REQUIRED,
  FIRST_NAME_REQUIRED,
  INVALID_MOBILE,
  INVALID_PASSWORD,
  INVALID_NAME,
  MOBILE_REQUIRED,
  INVALID_USERNAME,
  USERNAME_REQUIRED,
} = commonMessage;

export const auth = {
  // Login Schema
  loginSchema: {
    username: {
      required: true,
      message: USERNAME_REQUIRED,
      validate: (value, inputData = {}) => {
        return validateEmail(value) || validateMobileNumber(value);
      },
      invalidMessage: INVALID_USERNAME,
      extraMessage: true,
    },
    password: {
      required: true,
      message: PASSWORD_REQUIRED,
      extraMessage: false,
    },
  },

  //Send Verification Schema
  sendVerifyOtpSchema: {
    firstName: {
      required: true,
      message: FIRST_NAME_REQUIRED,
      validate: (value, inputData = {}) => {
        return validateName(value);
      },
      invalidMessage: INVALID_NAME,
      extraMessage: true,
    },
    email: {
      required: true,
      message: EMAIL_REQUIRED,
      validate: (value, inputData = {}) => {
        return validateEmail(value);
      },
      invalidMessage: INVALID_EMAIL,
      extraMessage: true,
    },
    mobile: {
      required: true,
      message: MOBILE_REQUIRED,
      validate: (value, inputData = {}) => {
        return validateMobileNumber(value);
      },
      invalidMessage: INVALID_MOBILE,
      extraMessage: true,
    },
    password: {
      required: true,
      message: PASSWORD_REQUIRED,
      validate: (value, inputData = {}) => {
        return validatePassword(value);
      },
      invalidMessage: INVALID_PASSWORD,
      extraMessage: true,
    },
    isRegister: { required: true },
    userRole: { require: true },
  },

  // Forgot Password Schema
  forgotPasswordSchema: {
    mobile: {
      required: true,
      message: MOBILE_REQUIRED,
      validate: (value, inputData = {}) => {
        return validateMobileNumber(value);
      },
      invalidMessage: INVALID_MOBILE,
      extraMessage: true,
    },
    isRegister: { required: true },
  },

  // Reset Password Schema
  resetPasswordSchema: {
    newPassword: {
      required: true,
      message: NEW_PASSWORD_REQUIRED,
      validate: (value, inputData = {}) => {
        return validatePassword(value);
      },
      invalidMessage: INVALID_PASSWORD,
      extraMessage: true,
    },
    confirmPassword: {
      required: true,
      message: CONFIRM_PASSWORD_REQUIRED,
      validate: (value, inputData = {}) => {
        return validatePassword(value);
      },
      invalidMessage: INVALID_PASSWORD,
      extraMessage: true,
    },
  },
};
